import { Fragment, type PropsWithChildren } from 'react';

function Page(props: PropsWithChildren) {
  const { children } = props;
  return <Fragment>{children}</Fragment>;
}

Page.displayName = 'Page';
export default Page;
